var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('app-account-link',{attrs:{"activity":_vm.activity}}),_vm._v("を作成しました。")],1)}
var staticRenderFns = []

export { render, staticRenderFns }